import React, { useState, useEffect, useRef } from "react";
import AppHeader from "../Components/appHeader";
import MainScanTile from "../Components/mainScanTile";
import { slice } from "../Redux/mainRedux/mainSlice";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../Redux/mainRedux/mainActions";
import ErrorMessage from "../Components/errorMessage";
import WarningMessage from "../Components/warningMessage";
import ConfirmationPopup from "../Components/ConfirmationPopup";
import TimerFooter from "../Components/timerFooter";
import TimerFooterCountup from "../Components/timerFooterCountup";
import PauseTimer from "../Components/pauseTimer";
import AudioPlayer from "../Components/audioPlayer";
import Backdrop from "@mui/material/Backdrop";
import BottomSlide from "../Components/bottomSlide";
import AppButton from "../Components/appButton";
import { hideKeyboard } from '../utility/hideKeyboard';

const ScanScreenType3 = () => {
  const { baseAPIURL, next_pick, token, warehouse, sessionStorage, apiSuccess, error, warning, timer, totalTimeSpend, timerdetail, pauseTime, pauseCount, keyboardStatus, userType } = useSelector(state => state.slice);
  const dispatch = useDispatch();
  const [scanVal, setScanVal] = useState(null)
  const [errorOpen, setErrorOpen] = useState(false);
  const [warningOpen, setWarningOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [checkReprintClick, setReprintClick] = useState(false);
  const [checkCountdown, setCountDown] = useState(false)
  const [checkShowCountDown, setShowCountDown] = useState(false)
  const [checkRestartTimer, setRestartTimer] = useState(false)
  const [checkPopupHolder, setPopupHolder] = useState(null);
  const [checkPause, setPause] = useState(false)
  const [totalTime, setTotalTime] = useState(0);
  const [totalPauseTime, setTotalPauseTime] = useState(0);
  const [scanError, setScanError] = useState(false);
  const [checkSuccessBeep, setSuccessBeep] = useState(false)
  const [showExitPopupVal, setExitPopupVal] = useState(false);
  const [hideArea, setHideArea] = useState(true)
  const [checkBottomSlider, setBottomSlider] = useState(false);
  const [checkBottomSliderVal, setBottomSliderVal] = useState(null);

  let sound1 = "/Assets/audio/beep90.mp3";
  let sound2 = "/Assets/audio/goodscan.mp3";
  let sound3 = "/Assets/audio/badscan.mp3";
  let scanErrorMessage = {
    'detail': 'Barcode not recognized. Please scan again properly.'
  }

  window.scrollEnable = function () {
    setHideArea(false)
  }
  window.scrollDisable = function () {
    setHideArea(true)
  }

  const inputRef = useRef();

  const scanHandler = e => {
    e.preventDefault()
    if (e.key === "Enter" || e.type === "click") {
      hideKeyboard();
      if (inputRef.current.value) {
        setSuccessBeep(false)
        dispatch(slice.actions.setApiSuccess(false))
        let body = {
          pause_duration: pauseTime,
          pause_count: pauseCount,
          net_time_consumed: totalTime,
          warehouse_name: warehouse,
          isd: next_pick.isd,
          pallet_identifier: inputRef.current.value,
          item: next_pick.item,
          apiSessionStorage: sessionStorage
        };
        inputRef.current.value = "";

        hideKeyboard();
        dispatch(actions.generic_call(baseAPIURL, next_pick.callback_url, body, 'post', token));
      } else {
        hideKeyboard();
        setScanError(true);
        setErrorOpen(true);
      }
    }
  }

  const printCartonLabelsByPickTicketId = () => {
    // let body = { pick_ticket_id: next_pick.pick_ticket_id, apiSessionStorage: sessionStorage }
    // dispatch(actions.generic_call('pickpack/printCartonLabelsByPickTicketId', body, 'post', token));
    setReprintClick(true);
    setConfirmOpen(true);
  }

  // For Error Message
  const errorCloseHandler = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ name: 'hide_keyboard' }))
    }
    setScanError(false);
    setErrorOpen(false);
    if (error.call_back_url && error.call_back_url_params) redirectAfterError(error)
    dispatch(slice.actions.clearError());
  };

  const onExitClickHandler = () => {
    setReprintClick(false);
    setConfirmOpen(true);
  }

  const confirmationCloseHandler = () => {
    setConfirmOpen(false);
  };

  const confirmationActionHandler = (data) => {
    setConfirmOpen(false);
    if (data.on_click_url) {
      if (data.title === "No" && data?.popup_message) {
        setPopupHolder(data)
        setErrorOpen(true);
        setTimeout(() => {
          redirectAfterConfirmation(data);
          // setErrorOpen(false);
          // dispatch(slice.actions.clearError());
          // setPopupHolder(null)
        }, 2000);
      } else {
        redirectAfterConfirmation(data);
      }
    }
  };

  const redirectAfterConfirmation = (data) => {
    let body = { ...data.on_click_url_params, apiSessionStorage: sessionStorage };
    dispatch(actions.generic_call(baseAPIURL, data.on_click_url, body, 'post', token));
  }

  // This will only come when there is RLLP is already created or call back URL is comes in error block
  const redirectAfterError = (data) => {
    let body = { ...data.call_back_url_params, apiSessionStorage: sessionStorage };
    dispatch(actions.generic_call(baseAPIURL, data.call_back_url, body, 'post', token));
  }

  useEffect(() => {
    // check error
    if (error) {
      setErrorOpen(true)
      if (error.code === 306) {
        setTimeout(() => {
          redirectAfterSessionExpire();
          localStorage.clear();
          setErrorOpen(false)
          dispatch(slice.actions.clearError());
        }, 2000);
      }
    }
    else {
      setErrorOpen(false)
    }

    // check warning
    if (warning) {
      setWarningOpen(true)
      setTimeout(() => {
        setWarningOpen(false);
        dispatch(slice.actions.clearWarning());
      }, 2000);
    } else {
      setWarningOpen(false)
    }
  }, [error, warning]);

  useEffect(() => {
    apiSuccess && resetTimer()
  }, [apiSuccess])

  const resetTimer = () => {
    dispatch(slice.actions.setTotalTimeSpend(null));
    setSuccessBeep(true)
    if (checkCountdown) {
      setCountDown(false);
      setShowCountDown(true);
      setRestartTimer(true);
    } else {
      if (checkShowCountDown) {
        setShowCountDown(false);
      }
      setTimeout(() => {
        setShowCountDown(true);
        setRestartTimer(true);
      }, 500);
    }
  }

  const redirectAfterSessionExpire = () => {
    dispatch(slice.actions.setPage('login'));
  }

  const exitClickPopup = (val) => {
    setExitPopupVal(val);
  }

  const routeOnExit = (callbackparam, callback_url) => {
    setExitPopupVal(false);
    let body = { ...callbackparam, apiSessionStorage: sessionStorage };
    dispatch(actions.generic_call(baseAPIURL, callback_url, body, 'post', token));
  }

  const onSubHeaderDescClick = (e) => {
    if (e.length > 24) {
      setBottomSlider(true)
      setBottomSliderVal(null)
      setBottomSliderVal(e)
    }
  }

  // for long item length on mainScanTile
  const onLongItemNameClick = (e) => {
    if (e.length > 20) {
      setBottomSlider(true)
      setBottomSliderVal(null)
      setBottomSliderVal(e)
    }
  }

  const closeHandle = () => {
    setBottomSlider(false)
  }

  return (
    <>
      <AppHeader
        pauseStatus={checkPause}
        checkCountdown={checkCountdown}
        menuIconVisible={false}
        backIconVisible={false}
        textVisible={true}
        text={next_pick.title}
        waveDesc={next_pick?.description}
        onHeaderDescClick={onSubHeaderDescClick}
        warehouseName={next_pick?.warehouse_selector_button_text}
        warehouseEnable={next_pick?.warehouse_list?.length > 0 ? true : false}
      />

      <div className="cpt-10 cpl-15 cpr-15 cpb-15 backgroundColor-Type5 mainPageType4">
        <div className="wfScreen">
          <div className="row">
            <div className="col-sm-12 col-xs-12 col-12">
              <MainScanTile
                unboundedText={next_pick.blue_text}
                boundedText={next_pick.blue_dotted_text}
                InputPlaceholder={next_pick.scan_text}
                numericKeyboard={next_pick?.numeric_keyboard}
                inputEl={next_pick.scan_text}
                palletQtyAndLocation={next_pick.locations_with_pallet_qty ? true : false}
                locationQtyPallet_List={next_pick.locations_with_pallet_qty}
                onScanHandler={scanHandler}
                scanValue={setScanVal}
                inputRef={inputRef}
                onKeyUp={scanHandler}
                scanText={scanVal}
                onLongItemNameClick={onLongItemNameClick}
              />
            </div>

            {checkPause &&
              <PauseTimer
                totalPauseTime={setTotalPauseTime}
              />
            }
            {
              userType != 'v1' ?
                (
                  <div className={`footer fixed-bottom ${keyboardStatus && 'focused'}`}>
                    {((!checkCountdown && checkShowCountDown) || (!next_pick.rfTimerValues)) &&
                      <TimerFooter
                        reprint_data={next_pick.reprint_btn}
                        pick_ticket_id={next_pick.pick_ticket_id}
                        onreprintclick={printCartonLabelsByPickTicketId}
                        onExitClick={onExitClickHandler}
                        actualTimer={next_pick.rfTimerValues}
                        expiryTimestamp={timer}
                        checkCountdown={setCountDown}
                        restartTimer={checkRestartTimer}
                        checkPause={setPause}
                        totalTime={setTotalTime}
                        totalPauseTime={totalPauseTime}
                        // this will send the boolean value
                        enableExit={next_pick.hasOwnProperty('exit_button_response')}
                      />
                    }
                    {checkCountdown &&
                      <TimerFooterCountup
                        reprint_data={next_pick.reprint_btn}
                        pick_ticket_id={next_pick.pick_ticket_id}
                        onreprintclick={printCartonLabelsByPickTicketId}
                        onExitClick={onExitClickHandler}
                        checkPause={setPause}
                        totalTime={setTotalTime}
                        totalPauseTime={totalPauseTime}
                        // this will send the boolean value
                        enableExit={next_pick.hasOwnProperty('exit_button_response')}
                      />
                    }
                  </div>
                ) : null
            }


            {(((checkCountdown) && (!checkPause) && (timerdetail?.cutoff_2_time > 0) && (timerdetail?.is_beep_enable === "Y")) || ((error?.code === 409))) &&
              <AudioPlayer
                sound={error?.code === 409 ? sound3 : sound1}
                loop={error?.code === 409 ? false : true}
                muted={(error?.code === 409) ? false : (totalTimeSpend > timerdetail?.cutoff_2_time ? false : true)}
              />
            }
            {(next_pick?.beep_code === 200 && checkSuccessBeep) &&
              <AudioPlayer
                sound={sound2}
                loop={false}
                muted={false}
              />
            }
            {checkPause &&
              <Backdrop sx={{ color: "#fff" }} open={true} />
            }
          </div>
          {next_pick?.mini_exit_btn && hideArea &&
            <div className="d-flex col-sm-6 col-xs-6 cpl-2">
              <div className={"ExitTile backgroundColor-Type3 font-small"} onClick={() => exitClickPopup(true)}>
                <span className="font-medium textColor-Type8">{next_pick?.mini_exit_btn?.btn_text}</span>
              </div>
            </div>
          }
        </div>
      </div>
      {
        <BottomSlide open={showExitPopupVal} closeHandle={() => exitClickPopup(false)}>
          <div className="w-100">
            <h5 className="text-center my-4">{next_pick?.mini_exit_btn?.blue_text}</h5>
            <div className="d-flex gap-2 p-2">
              <AppButton displayText={next_pick?.mini_exit_btn?.btn_option[0].title} onClick={() => routeOnExit(next_pick?.mini_exit_btn?.btn_option[0].on_click_url_params, next_pick?.mini_exit_btn?.btn_option[0].on_click_url)} />
              <AppButton displayText={next_pick?.mini_exit_btn?.btn_option[1].title} onClick={() => exitClickPopup(false)} isOutlined={true} />
            </div>
          </div>
        </BottomSlide>
      }
      <BottomSlide
        children={checkBottomSliderVal}
        open={checkBottomSlider}
        closeHandle={closeHandle}
      />
      {confirmOpen && <ConfirmationPopup open={confirmOpen} onClose={confirmationCloseHandler} data={checkReprintClick ? next_pick.reprint_btn : next_pick.exit_button_response} actionHandler={confirmationActionHandler} />}
      {errorOpen && <ErrorMessage open={errorOpen} onClose={errorCloseHandler} error={scanError ? scanErrorMessage : (checkPopupHolder ? checkPopupHolder : error)} />}
      {warningOpen && <WarningMessage open={warningOpen} warning={warning} />}
    </>
  );
};

export default ScanScreenType3;
